import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './PressPage.css';

import pressHero from '../../../assets/press-hero.png';
import mensHealthLogo from '../../../assets/press-menshealth-logo.png';
import mensHealthImg from '../../../assets/press-menshealth-img.png';
import graziaLogo from '../../../assets/press-grazia-logo.png';
import graziaImg from '../../../assets/press-grazia-img.png';
import playboyLogo from '../../../assets/press-playboy-logo.png';
import playboyImg from '../../../assets/press-playboy-img.png';
import foodTravelLogo from '../../../assets/logo-FT-Mx-blanco.png';
import foodTravelVideoImg from '../../../assets/foodtravel-thumbnail.jpg';
import kenaImg from '../../../assets/KENA.png';
import kenaLogo from '../../../assets/kena-logo.png';
import coolMaterialImg from '../../../assets/COOLMATERIAL.png';
import coolMaterialLogo from '../../../assets/cool-material-logo.png';
import chicLogo from '../../../assets/chic-logo.png';
import chicImg1 from '../../../assets/chic-playa.png';
import chicImg2 from '../../../assets/chic-aerea.jpeg';
import chicImg3 from '../../../assets/chic-noche.png';

const pressAssets: Record<string, { img: string; logo: string }> = {
  menshealth: { img: mensHealthImg, logo: mensHealthLogo },
  grazia: { img: graziaImg, logo: graziaLogo },
  playboy: { img: playboyImg, logo: playboyLogo },
  kena: { img: kenaImg, logo: kenaLogo },
  coolmaterial: { img: coolMaterialImg, logo: coolMaterialLogo },
  chic1: { img: chicImg1, logo: chicLogo },
  chic2: { img: chicImg2, logo: chicLogo },
  chic3: { img: chicImg3, logo: chicLogo },
};

interface ArticleData {
  id: string;
  description: string;
  link: string;
}

const PressPage: React.FC = () => {
  const { t } = useTranslation();

  
  const articles = t('pressPage:articles', { returnObjects: true }) as ArticleData[] | undefined;
  const articlesData = Array.isArray(articles) ? articles : [];

  return (
    <div className="press-page-container">
      <header
        className="press-hero"
        style={{ backgroundImage: `url(${pressHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">
          <Trans i18nKey="pressPage:title" />
        </h1>
      </header>

      <section className="press-grid-section">
        <div className="press-grid">
          {articlesData.map((article, index) => {
            const assets = pressAssets[article.id];
            if (!assets) return null; 

            return (
              <article className="press-card" key={index}>
                <img src={assets.img} alt={article.id} className="press-card-image" />
                <div className="press-logo-box">
                  <img src={assets.logo} alt={`${article.id} Logo`} className={`press-card-logo logo-${article.id}`} />
                </div>
                <p className="press-card-description">
                  {article.description}
                </p>
                <a 
                  href={article.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="press-card-link"
                >
                  
                  <Trans i18nKey="pressPage:moreInfo" />
                </a>
              </article>
            );
          })}
        </div>
      </section>

     
      <section className="food-travel-section">
        <div className="ft-grid">
          <div className="ft-logo-container">
            <img src={foodTravelLogo} alt="Food & Travel Logo" className="ft-logo" />
          </div>
          <div className="ft-video-container">
            <a href="https://www.instagram.com/p/DOez6HFFMT5/" target="_blank" rel="noopener noreferrer" className="ft-video-link">
              <img src={foodTravelVideoImg} alt="Villas Flamingos - Food & Travel Video" className="ft-video-thumbnail" />
              <div className="play-button-overlay">▶</div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PressPage;